import { gql } from '@urql/core';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Time: { input: string; output: string };
};

export enum AssetCode {
  Ghs = 'GHS',
  Usd = 'USD',
}

export type BasicResponse = {
  __typename?: 'BasicResponse';
  success: Scalars['Boolean']['output'];
};

export enum CollectionOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type CreateOrgInput = {
  name: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralSettings = {
  __typename?: 'GeneralSettings';
  defaultCurrencyISOCode: Scalars['String']['output'];
};

export enum LedgerRole {
  DistributionAccount = 'DISTRIBUTION_ACCOUNT',
  FeeCollectionAccount = 'FEE_COLLECTION_ACCOUNT',
  FeePayingAccount = 'FEE_PAYING_ACCOUNT',
  IssuerAccount = 'ISSUER_ACCOUNT',
  SequenceBumpAccount = 'SEQUENCE_BUMP_ACCOUNT',
}

export type Mutation = {
  __typename?: 'Mutation';
  logout?: Maybe<BasicResponse>;
  orgCreate?: Maybe<Org>;
};

export type MutationOrgCreateArgs = {
  input: CreateOrgInput;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Org = {
  __typename?: 'Org';
  createdAt: Scalars['Time']['output'];
  generalSettings: GeneralSettings;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isRestricted: Scalars['Boolean']['output'];
  logoMimeType?: Maybe<Scalars['String']['output']>;
  logoPath?: Maybe<Scalars['String']['output']>;
  logoSize?: Maybe<Scalars['Int']['output']>;
  logoUploadedAt?: Maybe<Scalars['Time']['output']>;
  logoUploadedByUserID?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  me?: Maybe<User>;
  org?: Maybe<Org>;
};

export type QueryOrgArgs = {
  orgId: Scalars['ID']['input'];
};

export enum RequirementCondition {
  AllOf = 'ALL_OF',
  AnyOf = 'ANY_OF',
}

export enum SignerSecurityLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type User = Node & {
  __typename?: 'User';
  authenticatedUser?: Maybe<User>;
  createdAt: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  hasSuperPermission: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgs?: Maybe<Array<Org>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
};

export type UserOrgsArgs = {
  orgSlug?: InputMaybe<Scalars['String']['input']>;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = {
  __typename?: 'Mutation';
  logout?: { __typename?: 'BasicResponse'; success: boolean } | null;
};

export type OrgCreateMutationVariables = Exact<{
  input: CreateOrgInput;
}>;

export type OrgCreateMutation = {
  __typename?: 'Mutation';
  orgCreate?: {
    __typename?: 'Org';
    id: string;
    name: string;
    slug: string;
    isActive: boolean;
  } | null;
};

export type MeQueryVariables = Exact<{
  orgSlug?: InputMaybe<Scalars['String']['input']>;
}>;

export type MeQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'User';
    id: string;
    name: string;
    email: string;
    phoneNumber?: string | null;
    createdAt: string;
    profileImage?: string | null;
    isAnonymous: boolean;
    orgs?: Array<{
      __typename?: 'Org';
      id: string;
      name: string;
      slug: string;
      isActive: boolean;
    }> | null;
    authenticatedUser?: {
      __typename?: 'User';
      id: string;
      name: string;
      email: string;
      phoneNumber?: string | null;
      createdAt: string;
      profileImage?: string | null;
      isAnonymous: boolean;
      orgs?: Array<{
        __typename?: 'Org';
        id: string;
        name: string;
        slug: string;
        isActive: boolean;
      }> | null;
    } | null;
  } | null;
};

export const LogoutDocument = gql`
  mutation logout {
    logout {
      success
    }
  }
`;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
}
export const OrgCreateDocument = gql`
  mutation orgCreate($input: CreateOrgInput!) {
    orgCreate(input: $input) {
      id
      name
      slug
      isActive
    }
  }
`;

export function useOrgCreateMutation() {
  return Urql.useMutation<OrgCreateMutation, OrgCreateMutationVariables>(OrgCreateDocument);
}
export const MeDocument = gql`
  query me($orgSlug: String) {
    me {
      id
      name
      email
      phoneNumber
      createdAt
      profileImage
      isAnonymous
      orgs(orgSlug: $orgSlug) {
        id
        name
        slug
        isActive
      }
      authenticatedUser {
        id
        name
        email
        phoneNumber
        createdAt
        profileImage
        isAnonymous
        orgs(orgSlug: $orgSlug) {
          id
          name
          slug
          isActive
        }
      }
    }
  }
`;

export function useMeQuery(options?: Omit<Urql.UseQueryArgs<MeQueryVariables>, 'query'>) {
  return Urql.useQuery<MeQuery, MeQueryVariables>({ query: MeDocument, ...options });
}
